import { render, staticRenderFns } from "./opencart-plugin-page.vue?vue&type=template&id=086f52e3&scoped=true"
import script from "./opencart-plugin-page.vue?vue&type=script&lang=js"
export * from "./opencart-plugin-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086f52e3",
  null
  
)

export default component.exports